import { all, put, call, takeLatest, select } from 'redux-saga/effects'

import {
  getInteraction,
  closeTicket as closeTicketRequest,
  sendFeedback as sendFeedbackRequest,
  sendDisagreement as sendDisagreementRequest
} from '../api'
import { apiError, showPopup } from '../helpers'
import { captureException } from '../helpers/Sentry'
import { logout } from './auth'

const initialState = {
  token: '',
  isModalOpen: false,
  interactionId: '',
  interaction: {},
  loading: false,
  loadingRequest: false,
  error: {},
  success: false
}

export const moduleName = 'email'

export const FETCH_INTERACTION_REQUEST = `${moduleName}/FETCH_INTERACTION_REQUEST`
export const FETCH_INTERACTION_SUCCESS = `${moduleName}/FETCH_INTERACTION_SUCCESS`
export const FETCH_INTERACTION_FAIL = `${moduleName}/FETCH_INTERACTION_FAIL`

export const CLOSE_TICKET_REQUEST = `${moduleName}/CLOSE_TICKET_REQUEST`
export const CLOSE_TICKET_SUCCESS = `${moduleName}/CLOSE_TICKET_SUCCESS`
export const CLOSE_TICKET_FAIL = `${moduleName}/CLOSE_TICKET_FAIL`

export const SEND_FEEDBACK_REQUEST = `${moduleName}/SEND_FEEDBACK_REQUEST`
export const SEND_FEEDBACK_SUCCESS = `${moduleName}/SEND_FEEDBACK_SUCCESS`
export const SEND_FEEDBACK_FAIL = `${moduleName}/SEND_FEEDBACK_FAIL`

export const SEND_DISAGREEMENT_REQUEST = `${moduleName}/SEND_DISAGREEMENT_REQUEST`
export const SEND_DISAGREEMENT_SUCCESS = `${moduleName}/SEND_DISAGREEMENT_SUCCESS`
export const SEND_DISAGREEMENT_FAIL = `${moduleName}/SEND_DISAGREEMENT_FAIL`

export const TOGGLE_MODAL = `${moduleName}/TOGGLE_MODAL`

export default function reducer(state = initialState, action) {
  const { type, payload } = action

  switch (type) {
    case FETCH_INTERACTION_REQUEST:
      return { ...state, ...payload, loading: true, error: {} }
    case FETCH_INTERACTION_SUCCESS:
      return {
        ...state,
        loading: false,
        error: {},
        isModalOpen: true,
        ...payload
      }
    case FETCH_INTERACTION_FAIL:
      return { ...state, loading: false, error: payload }

    case CLOSE_TICKET_REQUEST:
    case SEND_FEEDBACK_REQUEST:
    case SEND_DISAGREEMENT_REQUEST:
      return { ...state, loadingRequest: true }

    case CLOSE_TICKET_FAIL:
    case SEND_FEEDBACK_FAIL:
    case SEND_DISAGREEMENT_FAIL:
      return { ...state, loadingRequest: false, error: payload }

    case SEND_FEEDBACK_SUCCESS:
    case SEND_DISAGREEMENT_SUCCESS:
      return {
        ...state,
        loadingRequest: false,
        success: true,
        isModalOpen: false
      }

    case TOGGLE_MODAL:
      return { ...state, isModalOpen: !state.isModalOpen }

    default:
      return state
  }
}

export function fetchInteraction(payload) {
  return {
    type: FETCH_INTERACTION_REQUEST,
    payload
  }
}

export function toggleModal() {
  return {
    type: TOGGLE_MODAL
  }
}

export function closeTicket(data) {
  return {
    type: CLOSE_TICKET_REQUEST,
    payload: data
  }
}

export function sendFeedback(data) {
  return {
    type: SEND_FEEDBACK_REQUEST,
    payload: data
  }
}

export function sendDisagreement(data) {
  return {
    type: SEND_DISAGREEMENT_REQUEST,
    payload: data
  }
}

export const fetchInteractionSaga = function*() {
  try {
    const { interactionId, token } = yield select(({ email }) => email)
    const interaction = yield call(getInteraction, interactionId, token)
    yield put({
      type: FETCH_INTERACTION_SUCCESS,
      payload: { interaction }
    })
  } catch (e) {
    yield put(showPopup(e))
    if (e instanceof apiError) {
      const { code, message } = e
      yield put({
        type: FETCH_INTERACTION_FAIL,
        payload: {
          code,
          message
        }
      })
      if (code === 2) {
        yield put(logout())
      }
    } else {
      yield put({
        type: FETCH_INTERACTION_FAIL,
        payload: {
          code: 0,
          message: 'look what I got!'
        }
      })
      // TODO call some cross-screen error
      captureException(e)
    }
  }
}

export const closeTicketSaga = function*(action) {
  try {
    const { interactionId, token } = yield select(({ email }) => email)
    const response = yield call(closeTicketRequest, interactionId, token)
    yield put({
      type: CLOSE_TICKET_SUCCESS,
      payload: { data: response }
    })

    const { mark, mark2, mark3 } = action.payload

    if (mark && mark2 && mark3) {
      yield put(sendFeedback(action.payload))
    }
  } catch (e) {
    yield put(showPopup(e))
    if (e instanceof apiError) {
      const { code, message } = e
      yield put({
        type: CLOSE_TICKET_FAIL,
        payload: {
          code,
          message
        }
      })
      if (code === 2) {
        yield put(logout())
      }
    } else {
      yield put({
        type: CLOSE_TICKET_FAIL,
        payload: {
          code: 0,
          message: 'look what I got!'
        }
      })
      // TODO call some cross-screen error
      captureException(e)
    }
  }
}

export const sendFeedbackSaga = function*(action) {
  try {
    const { interactionId, token } = yield select(({ email }) => email)

    const response = yield call(
      sendFeedbackRequest,
      interactionId,
      action.payload,
      token
    )
    yield put({
      type: SEND_FEEDBACK_SUCCESS,
      payload: { data: response }
    })
  } catch (e) {
    yield put(showPopup(e))
    if (e instanceof apiError) {
      const { code, message } = e
      yield put({
        type: SEND_FEEDBACK_FAIL,
        payload: {
          code,
          message
        }
      })
      if (code === 2) {
        yield put(logout())
      }
    } else {
      yield put({
        type: SEND_FEEDBACK_FAIL,
        payload: {
          code: 0,
          message: 'look what I got!'
        }
      })
      // TODO call some cross-screen error
      captureException(e)
    }
  }
}

export const sendDisagreementSaga = function*(action) {
  try {
    const { interactionId, token } = yield select(({ email }) => email)
    const comment = action.payload
    const response = yield call(
      sendDisagreementRequest,
      interactionId,
      comment,
      token
    )

    yield put({
      type: SEND_DISAGREEMENT_SUCCESS,
      payload: { data: response }
    })
  } catch (e) {
    yield put(showPopup(e))
    if (e instanceof apiError) {
      const { code, message } = e
      yield put({
        type: SEND_DISAGREEMENT_SUCCESS,
        payload: {
          code,
          message
        }
      })
      if (code === 2) {
        yield put(logout())
      }
    } else {
      yield put({
        type: SEND_DISAGREEMENT_SUCCESS,
        payload: {
          code: 0,
          message: 'look what I got!'
        }
      })
      // TODO call some cross-screen error
      captureException(e)
    }
  }
}

export const saga = function*() {
  yield all([
    takeLatest(FETCH_INTERACTION_REQUEST, fetchInteractionSaga),
    takeLatest(CLOSE_TICKET_REQUEST, closeTicketSaga),
    takeLatest(SEND_FEEDBACK_REQUEST, sendFeedbackSaga),
    takeLatest(SEND_DISAGREEMENT_REQUEST, sendDisagreementSaga)
  ])
}
